import { ProfileUtils, useProfile } from "@brg/auth";
import { useModal } from "core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearLock, fetchLockData, fetchLockStatus, refreshLock, setLock } from "shared/actions/lockerActions";
import { LockedSelector } from "shared/reducers/LockerSlice";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { API, Designer, DesignerAPI } from "@brg/api";



export const useLocker = () => {
    const profile = useProfile();
    const dispatch = useDispatch();
    const location = useLocation();
    const modal = useModal();
    const { id: objectId } = useParams<{ id: string }>();
    const { i18n: { language } } = useTranslation();
    const { isLocked: canEdit, lockedData, isFetching } = useSelector(LockedSelector);
    const [editor, setEditor] = useState<Designer>();
    const { lockOwner = '', lockedDate } = lockedData || {};
    
    const baseParams = useMemo(() => {
        if (profile && objectId) {
            return { objectId, accountId: profile?.accountId ?? ''}
        }
        return undefined;
    } , [profile, objectId ])

    useEffect(() => {
        if (lockOwner !== '') {
            DesignerAPI.Get({ idDesigner: lockOwner })
            .then((d) => d.json())
            .then((designer) => {
              setEditor(API.toLang(designer, language))
            })
        }
    } , [lockOwner, language])

    const editorData = useMemo(() => {
        if (editor && lockedDate) {
            const date = new Date(lockedDate)
            
            return {
                editorName: ProfileUtils.getFullNameString(editor) || 'unnamed',
                editorTime:  date?.toLocaleTimeString(language, { hour: '2-digit', minute: 'numeric',})
            }
        }
        return undefined;
    }, [editor, lockedDate, language, isFetching])

    const isMe = useMemo(
        () => {
            if (profile && editor) {
                return editor?.accountId === profile?.accountId;
            }
            return false;
        }
    , [editor, profile])

    const isTeamLocation = useMemo(() => {
        return location.pathname?.indexOf('team-edit') !== -1
    }, [location])

    const onSet = () => {
        dispatch(setLock({ objectId }))
    }

    const onRemove = useCallback(() => {
        if (isMe) {
            dispatch(clearLock(baseParams))
        }
    } , [baseParams, dispatch, isMe])

    const onRefresh = () => {
        dispatch(refreshLock({ objectId }))
    }

    useEffect(() => {
        if (baseParams) {
            dispatch(fetchLockStatus(baseParams))
        }
        if (!isMe) {
            dispatch(fetchLockData(baseParams))
        }
    }, [baseParams, isMe])

    useEffect(() => {
        if (!!canEdit && !!lockedData && objectId) {
            onSet();
        }
    }, [canEdit, isFetching, lockedData, objectId])

    useEffect(() => {
        if (!canEdit && editorData && !isMe) {
            modal.show('lock-data', editorData)
        }
    }, [editorData, canEdit, modal, isMe])

    useEffect(() => {
        if (isMe) {
            alert('dasdas')
            isTeamLocation ? onRefresh() : onRemove();
        }
    } , [isMe, isTeamLocation, canEdit, location.pathname])

    return {
        onLockRemove: onRemove
    };
}import { ProfileUtils, useProfile } from "@brg/auth";
import { useModal } from "core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearLock, fetchLockData, fetchLockStatus, refreshLock, setLock } from "shared/actions/lockerActions";
import { LockedSelector } from "shared/reducers/LockerSlice";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { API, Designer, DesignerAPI } from "@brg/api";



export const useLocker = () => {
    const profile = useProfile();
    const dispatch = useDispatch();
    const location = useLocation();
    const modal = useModal();
    const { id: objectId } = useParams<{ id: string }>();
    const { i18n: { language } } = useTranslation();
    const { isLocked: canEdit, lockedData, isFetching } = useSelector(LockedSelector);
    const [editor, setEditor] = useState<Designer>();
    const { lockOwner = '', lockedDate } = lockedData || {};
    
    const baseParams = useMemo(() => {
        if (profile && objectId) {
            return { objectId, accountId: profile?.accountId ?? ''}
        }
        return undefined;
    } , [profile, objectId ])

    useEffect(() => {
        if (lockOwner !== '') {
            DesignerAPI.Get({ idDesigner: lockOwner })
            .then((d) => d.json())
            .then((designer) => {
              setEditor(API.toLang(designer, language))
            })
        }
    } , [lockOwner, language])

    const editorData = useMemo(() => {
        if (editor && lockedDate) {
            const date = new Date(lockedDate)
            
            return {
                editorName: ProfileUtils.getFullNameString(editor) || 'unnamed',
                editorTime:  date?.toLocaleTimeString(language, { hour: '2-digit', minute: 'numeric',})
            }
        }
        return undefined;
    }, [editor, lockedDate, language, isFetching])

    const isMe = useMemo(
        () => {
            if (profile && editor) {
                return editor?.accountId === profile?.accountId;
            }
            return false;
        }
    , [editor, profile])

    const isTeamLocation = useMemo(() => {
        return location.pathname?.indexOf('team-edit') !== -1
    }, [location])

    const onSet = () => {
        dispatch(setLock({ objectId }))
    }

    const onRemove = useCallback(() => {
        if (isMe) {
            dispatch(clearLock(baseParams))
        }
    } , [baseParams, dispatch, isMe])

    const onRefresh = () => {
        dispatch(refreshLock({ objectId }))
    }

    useEffect(() => {
        if (baseParams) {
            dispatch(fetchLockStatus(baseParams))
        }
        if (!isMe) {
            dispatch(fetchLockData(baseParams))
        }
    }, [baseParams, isMe])

    useEffect(() => {
        if (!!canEdit && !!lockedData && objectId) {
            onSet();
        }
    }, [canEdit, isFetching, lockedData, objectId])

    useEffect(() => {
        if (!canEdit && editorData && !isMe) {
            modal.show('lock-data', editorData)
        }
    }, [editorData, canEdit, modal, isMe])

    useEffect(() => {
        if (isMe) {
            alert('dasdas')
            isTeamLocation ? onRefresh() : onRemove();
        }
    } , [isMe, isTeamLocation, canEdit, location.pathname])

    return {
        onLockRemove: onRemove
    };
}